import { createStoreCreator } from 'lib/store'
import reducer from 'reports/qm/reducers'

export default createStoreCreator(reducer)
